import appManualInvoiceItems from "../../views/appSettings/manualInvoiceItemsView.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "manual-invoice-items";
  const params = ["page", "limit"];

  $stateProvider.state("manualinvoiceitems", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appManualInvoiceItems,
      },
    },
    reloadOnSearch: false,
    data: { title: "ManualInvoiceItems" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/manualInvoiceItems/manualInvoiceItems.urls.js